// import React, { useState, useEffect, useRef } from "react";
// import { Link } from "react-router-dom";
// import AuthService from "../Authentication/authService";
// import { useNavigate } from "react-router-dom";
// import { FaUser, FaSignOutAlt, FaBell } from "react-icons/fa";
// import "../css/index.css"; // Ensure this contains .custom-container-width, .for-hover, .nav-profile-picture, .user-name-container etc.
// import ProfileModal from "./ProfileModal";
// import brandlogo from "../../Assets/VetrinaLogo.png";
// import { Popover, Badge, OverlayTrigger } from "react-bootstrap";
// import userprofile from "../../Assets/userprofile.png";
// import axios from "axios";

// export default function DashNavbar(props) {
//   const navigate = useNavigate();
//   const [showDropdown, setShowDropdown] = useState(false); // Controls visibility of the entire user section
//   const [userName, setUserName] = useState("");
//   const [showProfileModal, setShowProfileModal] = useState(false);
//   const [notifications, setNotifications] = useState([]);
//   const [userData, setUserData] = useState(null);
//   const [profilePictureBlobURL, setProfilePictureBlobURL] = useState(null);
//   const [notificationCount, setNotificationCount] = useState(0);

//   const hasFetchedProfilePicture = useRef(false);
//   const isMounted = useRef(true);

//   useEffect(() => {
//     isMounted.current = true;
//     // Initial fetch of user data and profile picture
//     const fetchData = async () => {
//       const email = localStorage.getItem("email");
//       if (email) {
//         try {
//           const response = await axios.post("https://raasbackend.vetrinahealthcare.com/UserProfile/", { email });
//           if (isMounted.current) {
//             setUserData(response.data.user_data);
//           }
//         } catch (error) {
//           console.error("Error fetching user data:", error.message);
//         }
//       }
//     };
//     fetchData();

//     // Fetch notifications on initial load if role and user ID exist
//     const storedRole = localStorage.getItem("User_Role");
//     const currentUserId = localStorage.getItem("user_id");
//     if (storedRole && currentUserId) {
//         fetchNotifications(storedRole, currentUserId);
//     }

//     // Set user name and show dropdown
//     const storedUserName = localStorage.getItem("UserName");
//     if (storedUserName) {
//       if (isMounted.current) {
//         setUserName(storedUserName);
//         setShowDropdown(true);
//       }
//     }
    
//     return () => {
//       isMounted.current = false;
//       if (profilePictureBlobURL) { // Clean up blob URL on unmount
//         URL.revokeObjectURL(profilePictureBlobURL);
//       }
//     };
//   }, []); // Empty dependency array for one-time setup on mount


//   useEffect(() => {
//     if (userData && userData.id && !profilePictureBlobURL && !hasFetchedProfilePicture.current) {
//       const fetchProfilePicture = async () => {
//         try {
//           const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/profile-picture/${userData.id}/`, { responseType: "blob" });
//           const blobURL = URL.createObjectURL(response.data);
//           if (isMounted.current) {
//             setProfilePictureBlobURL(blobURL);
//           }
//           hasFetchedProfilePicture.current = true;
//         } catch (error) {
//           console.error("Error fetching profile picture:", error.message);
//         }
//       };
//       fetchProfilePicture();
//     }
//     // The cleanup for profilePictureBlobURL is in the main unmount effect.
//   }, [userData, profilePictureBlobURL]); // Dependencies for profile picture fetching

//   const fetchNotifications = async (roleToFetch, currentUserIdString) => {
//     if (!currentUserIdString || !roleToFetch) {
//         console.warn("User ID or Role not found. Cannot fetch notifications.");
//         if(isMounted.current){
//             setNotifications([]);
//             setNotificationCount(0);
//         }
//         return;
//     }
//     const currentUserIdInt = parseInt(currentUserIdString);

//     try {
//       const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/get_notifications/?role=${roleToFetch}&user_id=${currentUserIdInt}`);
//       if (isMounted.current) {
//         const fetchedNotifications = response.data.notifications.map(notification => ({
//           ...notification,
//           seen: notification.seen_by.includes(currentUserIdInt) 
//         }));
//         setNotifications(fetchedNotifications);
        
//         const unseenCount = fetchedNotifications.filter(notification => !notification.seen).length;
//         setNotificationCount(unseenCount);
//       }
//     } catch (error) {
//       console.error("Error fetching notifications:", error);
//       if (isMounted.current) {
//         setNotifications([]);
//         setNotificationCount(0);
//       }
//     }
//   };

//   const handleProfileClick = () => {
//     if (isMounted.current) setShowProfileModal(true);
//   };

//   const handleLogout = () => {
//     AuthService.logout()
//       .then(() => {
//         localStorage.clear();
//         if (isMounted.current) {
//             setUserName("");
//             setShowDropdown(false);
//             setUserData(null);
//             if (profilePictureBlobURL) {
//               URL.revokeObjectURL(profilePictureBlobURL); // Explicit revoke on logout
//             }
//             setProfilePictureBlobURL(null);
//             setNotifications([]);
//             setNotificationCount(0);
//             hasFetchedProfilePicture.current = false;
//         }
//         navigate("/sign-in");
//       })
//       .catch((error) => {
//         console.error("Logout Error:", error);
//       });
//   };

//   const handleBellClick = () => {
//     const storedRole = localStorage.getItem("User_Role");
//     const currentUserId = localStorage.getItem("user_id");
//     if (storedRole && currentUserId) {
//         fetchNotifications(storedRole, currentUserId);
//     }
//   };

//   const getTimeDifference = (notificationTime) => {
//     const currentTime = new Date();
//     const notificationDate = new Date(notificationTime);
//     const timeDifference = currentTime.getTime() - notificationDate.getTime();
//     const seconds = Math.floor(timeDifference / 1000);
//     const minutes = Math.floor(seconds / 60);
//     const hours = Math.floor(minutes / 60);
//     const days = Math.floor(hours / 24);
//     if (days > 0) return `${days} day${days > 1 ? "s" : ""} ago`;
//     if (hours > 0) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
//     if (minutes > 0) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
//     if (seconds < 5) return "just now";
//     return `${seconds} second${seconds > 1 ? "s" : ""} ago`;
//   };

//   const handleNotificationClick = async (notificationId) => {
//     const currentUserIdString = localStorage.getItem("user_id");
//     if (!currentUserIdString) {
//         console.error("User ID not found in localStorage for marking notification.");
//         return;
//     }
//     const currentUserIdInt = parseInt(currentUserIdString);

//     const notificationIndex = notifications.findIndex(n => n.id === notificationId);
//     if (notificationIndex === -1) return;

//     const notification = notifications[notificationIndex];

//     // Only proceed if the notification exists and the CURRENT user hasn't seen it yet.
//     // (checked by `!notification.seen_by.includes(currentUserIdInt)`)
//     if (!notification.seen_by.includes(currentUserIdInt)) {
//         try {
//           await axios.post("https://raasbackend.vetrinahealthcare.com/mark_notification_as_seen/", {
//             notification_id: notificationId,
//             user_id: currentUserIdInt,
//           });
//           if (isMounted.current) {
//             const updatedNotifications = notifications.map((n, index) => {
//               if (index === notificationIndex) {
//                 // Create a new seen_by array for the updated notification
//                 const newSeenBy = n.seen_by.includes(currentUserIdInt) ? n.seen_by : [...n.seen_by, currentUserIdInt];
//                 return { ...n, seen: true, seen_by: newSeenBy };
//               }
//               return n;
//             });
//             setNotifications(updatedNotifications);
            
//             // Recalculate count based on the updated list and current user
//             const newUnseenCount = updatedNotifications.filter(n => !n.seen_by.includes(currentUserIdInt)).length;
//             setNotificationCount(newUnseenCount);
//           }
//         } catch (error) {
//           console.error("Error marking notification as seen:", error);
//         }
//     }
//   };

//   const notificationPopover = (
//     <Popover id="popover-notifications" style={{ minWidth: '300px', maxWidth: '400px'}}>
//       <Popover.Header as="h3" className="py-2 px-3">Notifications</Popover.Header>
//       <Popover.Body style={{ maxHeight: "70vh", overflowY: "auto", padding: 0 }}>
//         {notifications.length === 0 ? (
//             <div className="p-3 text-center text-muted">No new notifications.</div>
//         ) : (
//         <div className="list-group list-group-flush">
//           {[...notifications]
//             .sort((a, b) => {
//               const currentUserIdStr = localStorage.getItem("user_id");
//               const currentUserId = currentUserIdStr ? parseInt(currentUserIdStr) : null;

//               const aSeenByCurrentUser = currentUserId ? a.seen_by.includes(currentUserId) : false;
//               const bSeenByCurrentUser = currentUserId ? b.seen_by.includes(currentUserId) : false;

//               if (aSeenByCurrentUser && !bSeenByCurrentUser) return 1;
//               if (!aSeenByCurrentUser && bSeenByCurrentUser) return -1;
//               return new Date(b.time) - new Date(a.time);
//             })
//             .map((notification) => {
//               const currentUserIdStr = localStorage.getItem("user_id");
//               const currentUserId = currentUserIdStr ? parseInt(currentUserIdStr) : null;
//               const isSeenByCurrentUser = currentUserId ? notification.seen_by.includes(currentUserId) : false;

//               return (
//                 <div
//                   key={notification.id}
//                   className={`list-group-item list-group-item-action notification-item ${isSeenByCurrentUser ? 'seen text-muted' : 'unseen fw-bold'}`}
//                   onClick={() => handleNotificationClick(notification.id)}
//                   style={{ cursor: 'pointer', whiteSpace: 'normal', backgroundColor: isSeenByCurrentUser ? '#f8f9fa' : '#fff' }}
//                 >
//                   <p className="notification-msg mb-1" style={{ fontSize: '0.9rem' }}>{notification.message}</p>
//                   <small className="notification-time" style={{ fontSize: '0.75rem' }}>
//                     {getTimeDifference(notification.time)}
//                   </small>
//                 </div>
//               );
//             })}
//         </div>
//         )}
//       </Popover.Body>
//     </Popover>
//   );

//   return (
//     <>
//       <nav className="navbar navbar-expand navbar-light bg-white shadow-sm">
//         <div className="container-fluid custom-container-width px-3">
//           <div className="d-flex justify-content-between align-items-center w-100">
//             {/* Left Side: Brand Logo */}
//             <Link className="navbar-brand" to={"/Admindashboard"}> {/* Adjust link as per your routing */}
//               <img
//                 src={brandlogo}
//                 alt="Vetrina Logo"
//                 style={{ height: "1.7em", width: "auto", maxHeight: "40px" }}
//               />
//             </Link>

//             {/* Right Side: Notifications and User Profile Dropdown */}
//             <div className="d-flex align-items-center">
//               <OverlayTrigger
//                 trigger="click"
//                 placement="bottom-end"
//                 overlay={notificationPopover}
//                 rootClose
//               >
//                 <div
//                   className="bell-icon-wrapper me-3 position-relative"
//                   onClick={handleBellClick}
//                   style={{ cursor: "pointer" }}
//                   aria-label="Notifications"
//                 >
//                   <FaBell
//                     style={{
//                       fontSize: "1.5em",
//                       color: "#333",
//                     }}
//                   />
//                   {notificationCount > 0 && (
//                     <Badge
//                       pill
//                       bg="danger"
//                       className="position-absolute top-0 start-100 translate-middle"
//                       style={{ fontSize: '0.6em', padding: '0.3em 0.5em' }}
//                     >
//                       {notificationCount}
//                       <span className="visually-hidden">unread notifications</span>
//                     </Badge>
//                   )}
//                 </div>
//               </OverlayTrigger>

//               {/* User Dropdown Section */}
//               {showDropdown && userData && (
//                 <div className="dropdown">
//                   <div className="d-flex align-items-center">
//                     <span className="user-name-container">
//                       {userName && (
//                         <span className="user-name text-dark me-2">
//                           {userName}
//                         </span>
//                       )}
//                     </span>

//                     <div
//                       className="nav-profile-picture-container mx-2 position-relative"
//                       onClick={handleProfileClick}
//                       style={{ cursor: 'pointer' }}
//                     >
//                       <img
//                         src={
//                           profilePictureBlobURL ||
//                           (userData.profile_picture) || // Assuming userData.profile_picture is a direct URL from backend if blob fails
//                           userprofile // Fallback
//                         }
//                         alt="Profile"
//                         className="nav-profile-picture"
//                       />
//                     </div>

//                     <button
//                       className="px-2 border-0 dropdown-toggle"
//                       style={{
//                         backgroundColor: "transparent",
//                         color: "#333",
//                       }}
//                       type="button"
//                       id="userDropdownToggle"
//                       data-bs-toggle="dropdown"
//                       aria-expanded="false"
//                     ></button>

//                     <ul
//                       className="dropdown-menu dropdown-menu-end"
//                       aria-labelledby="userDropdownToggle"
//                     >
//                       <li>
//                         <button
//                           className="dropdown-item for-hover d-flex align-items-center"
//                           onClick={handleProfileClick}
//                         >
//                           <FaUser className="me-2" />
//                           Profile
//                         </button>
//                       </li>
//                       <li>
//                         <button
//                           className="dropdown-item for-hover d-flex align-items-center"
//                           onClick={handleLogout}
//                         >
//                           <FaSignOutAlt className="me-2" />
//                           Log out
//                         </button>
//                       </li>
//                     </ul>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </nav>

//       <ProfileModal
//         show={showProfileModal}
//         onClose={() => { if (isMounted.current) setShowProfileModal(false); }}
//         userName={userName}
//         userData={userData}
//       />
//     </>
//   );
// }


import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import AuthService from "../Authentication/authService";
import { useNavigate } from "react-router-dom";
import { FaUser, FaSignOutAlt, FaBell } from "react-icons/fa";
import "../css/index.css"; // Ensure this contains .custom-container-width, .for-hover, .nav-profile-picture, .user-name-container etc.
import ProfileModal from "./ProfileModal";
import brandlogo from "../../Assets/VetrinaLogo.png";
import { Popover, Badge, OverlayTrigger } from "react-bootstrap";
import userprofile from "../../Assets/userprofile.png";
import axios from "axios";

export default function DashNavbar(props) {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false); 
  const [userName, setUserName] = useState("");
  const [userRole, setUserRole] = useState(""); 
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [userData, setUserData] = useState(null);
  const [profilePictureBlobURL, setProfilePictureBlobURL] = useState(null);
  const [notificationCount, setNotificationCount] = useState(0);

  const hasFetchedProfilePicture = useRef(false);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    const fetchData = async () => {
      const email = localStorage.getItem("email");
      if (email) {
        try {
          const response = await axios.post("https://raasbackend.vetrinahealthcare.com/UserProfile/", { email });
          if (isMounted.current) {
            setUserData(response.data.user_data);
          }
        } catch (error) {
          console.error("Error fetching user data:", error.message);
        }
      }
    };
    fetchData();

    const storedRole = localStorage.getItem("User_Role");
    const currentUserId = localStorage.getItem("user_id");
    if (storedRole && currentUserId) {
        fetchNotifications(storedRole, currentUserId);
    }

    const storedUserName = localStorage.getItem("UserName");
    if (storedUserName) {
      if (isMounted.current) {
        setUserName(storedUserName);
        setShowDropdown(true);
      }
    }
    const localUserRole = localStorage.getItem("User_Role"); 
    if (localUserRole) {
      if (isMounted.current) {
        setUserRole(localUserRole); 
      }
    }
    
    return () => {
      isMounted.current = false;
      if (profilePictureBlobURL) { 
        URL.revokeObjectURL(profilePictureBlobURL);
      }
    };
  }, []); 


  useEffect(() => {
    if (userData && userData.id && !profilePictureBlobURL && !hasFetchedProfilePicture.current) {
      const fetchProfilePicture = async () => {
        try {
          const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/profile-picture/${userData.id}/`, { responseType: "blob" });
          const blobURL = URL.createObjectURL(response.data);
          if (isMounted.current) {
            setProfilePictureBlobURL(blobURL);
          }
          hasFetchedProfilePicture.current = true;
        } catch (error) {
          console.error("Error fetching profile picture:", error.message);
        }
      };
      fetchProfilePicture();
    }
  }, [userData, profilePictureBlobURL]);

  const fetchNotifications = async (roleToFetch, currentUserIdString) => {
    if (!currentUserIdString || !roleToFetch) {
        console.warn("User ID or Role not found. Cannot fetch notifications.");
        if(isMounted.current){
            setNotifications([]);
            setNotificationCount(0);
        }
        return;
    }
    const currentUserIdInt = parseInt(currentUserIdString);

    try {
      const response = await axios.get(`https://raasbackend.vetrinahealthcare.com/get_notifications/?role=${roleToFetch}&user_id=${currentUserIdInt}`);
      if (isMounted.current) {
        const fetchedNotifications = response.data.notifications.map(notification => ({
          ...notification,
          seen: notification.seen_by.includes(currentUserIdInt) 
        }));
        setNotifications(fetchedNotifications);
        
        const unseenCount = fetchedNotifications.filter(notification => !notification.seen).length;
        setNotificationCount(unseenCount);
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
      if (isMounted.current) {
        setNotifications([]);
        setNotificationCount(0);
      }
    }
  };

  const handleProfileClick = () => {
    if (isMounted.current) setShowProfileModal(true);
  };

  const handleLogout = () => {
    AuthService.logout()
      .then(() => {
        localStorage.clear();
        if (isMounted.current) {
            setUserName("");
            setUserRole(""); 
            setShowDropdown(false);
            setUserData(null);
            if (profilePictureBlobURL) {
              URL.revokeObjectURL(profilePictureBlobURL); 
            }
            setProfilePictureBlobURL(null);
            setNotifications([]);
            setNotificationCount(0);
            hasFetchedProfilePicture.current = false;
        }
        navigate("/sign-in");
      })
      .catch((error) => {
        console.error("Logout Error:", error);
      });
  };

  const handleBellClick = () => {
    const storedRole = localStorage.getItem("User_Role");
    const currentUserId = localStorage.getItem("user_id");
    if (storedRole && currentUserId) {
        fetchNotifications(storedRole, currentUserId);
    }
  };

  const getTimeDifference = (notificationTime) => {
    const currentTime = new Date();
    const notificationDate = new Date(notificationTime);
    const timeDifference = currentTime.getTime() - notificationDate.getTime();
    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    if (days > 0) return `${days} day${days > 1 ? "s" : ""} ago`;
    if (hours > 0) return `${hours} hour${hours > 1 ? "s" : ""} ago`;
    if (minutes > 0) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;
    if (seconds < 5) return "just now";
    return `${seconds} second${seconds > 1 ? "s" : ""} ago`;
  };

  const handleNotificationClick = async (notificationId) => {
    const currentUserIdString = localStorage.getItem("user_id");
    if (!currentUserIdString) {
        console.error("User ID not found in localStorage for marking notification.");
        return;
    }
    const currentUserIdInt = parseInt(currentUserIdString);

    const notificationIndex = notifications.findIndex(n => n.id === notificationId);
    if (notificationIndex === -1) return;

    const notification = notifications[notificationIndex];

    if (!notification.seen_by.includes(currentUserIdInt)) {
        try {
          await axios.post("https://raasbackend.vetrinahealthcare.com/mark_notification_as_seen/", {
            notification_id: notificationId,
            user_id: currentUserIdInt,
          });
          if (isMounted.current) {
            const updatedNotifications = notifications.map((n, index) => {
              if (index === notificationIndex) {
                const newSeenBy = n.seen_by.includes(currentUserIdInt) ? n.seen_by : [...n.seen_by, currentUserIdInt];
                return { ...n, seen: true, seen_by: newSeenBy };
              }
              return n;
            });
            setNotifications(updatedNotifications);
            
            const newUnseenCount = updatedNotifications.filter(n => !n.seen_by.includes(currentUserIdInt)).length;
            setNotificationCount(newUnseenCount);
          }
        } catch (error) {
          console.error("Error marking notification as seen:", error);
        }
    }
  };

  const notificationPopover = (
    <Popover id="popover-notifications" style={{ minWidth: '300px', maxWidth: '400px'}}>
      <Popover.Header as="h3" className="py-2 px-3">Notifications</Popover.Header>
      <Popover.Body style={{ maxHeight: "70vh", overflowY: "auto", padding: 0 }}>
        {notifications.length === 0 ? (
            <div className="p-3 text-center text-muted">No new notifications.</div>
        ) : (
        <div className="list-group list-group-flush">
          {[...notifications]
            .sort((a, b) => {
              const currentUserIdStr = localStorage.getItem("user_id");
              const currentUserId = currentUserIdStr ? parseInt(currentUserIdStr) : null;

              const aSeenByCurrentUser = currentUserId ? a.seen_by.includes(currentUserId) : false;
              const bSeenByCurrentUser = currentUserId ? b.seen_by.includes(currentUserId) : false;

              if (aSeenByCurrentUser && !bSeenByCurrentUser) return 1;
              if (!aSeenByCurrentUser && bSeenByCurrentUser) return -1;
              return new Date(b.time) - new Date(a.time);
            })
            .map((notification) => {
              const currentUserIdStr = localStorage.getItem("user_id");
              const currentUserId = currentUserIdStr ? parseInt(currentUserIdStr) : null;
              const isSeenByCurrentUser = currentUserId ? notification.seen_by.includes(currentUserId) : false;

              return (
                <div
                  key={notification.id}
                  className={`list-group-item list-group-item-action notification-item ${isSeenByCurrentUser ? 'seen text-muted' : 'unseen fw-bold'}`}
                  onClick={() => handleNotificationClick(notification.id)}
                  style={{ cursor: 'pointer', whiteSpace: 'normal', backgroundColor: isSeenByCurrentUser ? '#f8f9fa' : '#fff' }}
                >
                  <p className="notification-msg mb-1" style={{ fontSize: '0.9rem' }}>{notification.message}</p>
                  <small className="notification-time" style={{ fontSize: '0.75rem' }}>
                    {getTimeDifference(notification.time)}
                  </small>
                </div>
              );
            })}
        </div>
        )}
      </Popover.Body>
    </Popover>
  );

  return (
    <>
      <nav className="navbar navbar-expand navbar-light bg-white shadow-sm">
        <div className="container-fluid custom-container-width px-3">
          <div className="d-flex justify-content-between align-items-center w-100">
            <Link className="navbar-brand" to={"/Admindashboard"}>
              <img
                src={brandlogo}
                alt="Vetrina Logo"
                style={{ height: "1.7em", width: "auto", maxHeight: "40px" }}
              />
            </Link>

            <div className="navbar-title-container">
              <h1 className="navbar-title">VetTalent Hub</h1>
            </div>

            <div className="d-flex align-items-center">
              <OverlayTrigger
                trigger="click"
                placement="bottom-end"
                overlay={notificationPopover}
                rootClose
              >
                <div
                  className="bell-icon-wrapper me-3 position-relative"
                  onClick={handleBellClick}
                  style={{ cursor: "pointer" }}
                  aria-label="Notifications"
                >
                  <FaBell
                    style={{
                      fontSize: "1.5em",
                      color: "#333",
                    }}
                  />
                  {notificationCount > 0 && (
                    <Badge
                      pill
                      bg="danger"
                      className="position-absolute top-0 start-100 translate-middle"
                      style={{ fontSize: '0.6em', padding: '0.3em 0.5em' }}
                    >
                      {notificationCount}
                      <span className="visually-hidden">unread notifications</span>
                    </Badge>
                  )}
                </div>
              </OverlayTrigger>

              {showDropdown && userData && (
                <div className="dropdown">
                  <div className="d-flex align-items-center">
                    <div className="user-name-role-container me-2 text-end"> 
                      {userName && (
                        <span className="user-name text-dark d-block" style={{ fontWeight: '500', fontSize: '0.9rem' }}> 
                          {userName}
                        </span>
                      )}
                      {userRole && (
                        <span 
                          className="user-role d-block" // Removed text-muted to apply custom color
                          style={{ 
                            fontSize: '0.75rem', 
                            lineHeight: '1',
                            color: '#555555' // <<<<<<<<<<<<<<<<< DARK GREY COLOR APPLIED HERE
                          }}
                        > 
                          {userRole}
                        </span>
                      )}
                    </div>

                    <div
                      className="nav-profile-picture-container mx-2 position-relative"
                      onClick={handleProfileClick}
                      style={{ cursor: 'pointer' }}
                    >
                      <img
                        src={
                          profilePictureBlobURL ||
                          (userData.profile_picture) || 
                          userprofile 
                        }
                        alt="Profile"
                        className="nav-profile-picture"
                      />
                    </div>

                    <button
                      className="px-2 border-0 dropdown-toggle"
                      style={{
                        backgroundColor: "transparent",
                        color: "#333",
                      }}
                      type="button"
                      id="userDropdownToggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    ></button>

                    <ul
                      className="dropdown-menu dropdown-menu-end"
                      aria-labelledby="userDropdownToggle"
                    >
                      <li>
                        <button
                          className="dropdown-item for-hover d-flex align-items-center"
                          onClick={handleProfileClick}
                        >
                          <FaUser className="me-2" />
                          Profile
                        </button>
                      </li>
                      <li>
                        <button
                          className="dropdown-item for-hover d-flex align-items-center"
                          onClick={handleLogout}
                        >
                          <FaSignOutAlt className="me-2" />
                          Log out
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>

      <style jsx>{`
        .navbar-title-container {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
        }

        .navbar-title {
          font-size: 2.2em; 
          font-weight: 700;
          margin: 0;
          background: linear-gradient(90deg, #a82682, #a92984, #d46b0c, #a82682);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-size: 300% 100%; 
          animation: shimmer 5s linear infinite;
          text-shadow: 0 0 5px rgba(255, 255, 255, 0.3), 
                       0 0 10px rgba(142, 45, 226, 0.2); 
        }

        @keyframes shimmer {
          0% {
            background-position: 0% 50%;
          }
          100% {
            background-position: 100% 50%;
          }
        }
        
        .custom-container-width {
           
        }
        
        .user-name-role-container { 
            display: flex;
            flex-direction: column;
            align-items: flex-end; 
        }

        @media (max-width: 768px) {
          .navbar-title {
            font-size: 1.2em; 
          }
        }
         @media (max-width: 576px) {
          .navbar-title {
            display: none; 
          }
          .user-name-role-container { 
            display: none; 
          }
          .nav-profile-picture-container {
            margin-left: 0 !important; 
          }
        }
      `}</style>

      <ProfileModal
        show={showProfileModal}
        onClose={() => { if (isMounted.current) setShowProfileModal(false); }}
        userName={userName}
        userData={userData}
      />
    </>
  );
}